/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import TreeItemActions from './TreeItemActions';
import './ComponentTreeItemStyles.scss';
import isComponent from '../utils/isComponent';
export default function ComponentTreeItem({ item, options, onToggleActive, isTogglingActive, hideActions = false, onComponentClick, components = [], onEdit, onMove, onMoveTo, onMakeMainComponent, dragHandle, supportsSubcomponents = false }) {
    const { isDragging } = options;
    // Check if this is an attachable or component item
    const isAttachable = !isComponent(item.data);
    const attachableData = isAttachable ? item.data : null;
    const componentData = !isAttachable ? item.data : null;
    const handleItemClick = (e) => {
        // Only trigger click for components, not attachables
        if (!isAttachable && componentData && onComponentClick) {
            // Don't trigger if clicking on action buttons
            const target = e.target;
            const isActionButton = target.closest('.tree-item-actions');
            if (!isActionButton) {
                onComponentClick(Number(item.id));
            }
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleItemClick(e);
        }
    };
    const renderLocation = () => {
        if (!componentData || !componentData.location)
            return null;
        return (React.createElement("div", { className: "component-tree-item__location" },
            React.createElement("i", { className: "fa-regular fa-location-dot" }),
            React.createElement("span", null, componentData.location)));
    };
    const renderActions = () => {
        // Don't show actions if hideActions prop is true or if it's an attachable root item
        if (hideActions || isAttachable)
            return null;
        return (React.createElement(TreeItemActions, { item: item, components: components, onToggleActive: onToggleActive, isTogglingActive: isTogglingActive, onEdit: onEdit, onMove: onMove, onMoveTo: onMoveTo, onMakeMainComponent: onMakeMainComponent, supportsSubcomponents: supportsSubcomponents }));
    };
    // Render attachable root item (simplified, no drag/drop, location, type, status, or actions)
    if (isAttachable && attachableData) {
        return (React.createElement("div", { className: "component-tree-item component-tree-item--attachable" },
            React.createElement("div", { className: "component-tree-item__content" },
                React.createElement("div", { className: "component-tree-item__info" },
                    React.createElement("div", { className: "component-tree-item__primary" },
                        React.createElement("h4", { className: "component-tree-item__name" }, attachableData.displayName || attachableData.name),
                        attachableData.humanReadableType && (React.createElement("span", { className: "component-tree-item__type" }, attachableData.humanReadableType)))))));
    }
    // Render regular component item
    if (componentData) {
        return (React.createElement("div", { className: `
          component-tree-item 
          ${isDragging ? 'component-tree-item--dragging' : ''}
          ${!componentData.active ? 'component-tree-item--inactive' : ''}
          ${onComponentClick ? 'component-tree-item--clickable' : ''}
        `.trim(), onClick: handleItemClick, onKeyDown: onComponentClick ? handleKeyDown : undefined, role: onComponentClick ? 'button' : undefined, tabIndex: onComponentClick ? 0 : -1, "aria-label": onComponentClick ? `View details for ${componentData.name}` : undefined },
            React.createElement("div", { className: "component-tree-item__content" },
                React.createElement("div", { className: "component-tree-item__status-line" }),
                React.createElement("div", { className: "component-tree-item__info" },
                    React.createElement("div", { className: "component-tree-item__primary" },
                        dragHandle && React.createElement("div", { className: "component-tree-item__drag-handle" }, dragHandle),
                        React.createElement("h4", { className: "component-tree-item__name" }, componentData.name),
                        React.createElement("span", { className: "component-tree-item__type" }, componentData.type),
                        renderLocation())),
                React.createElement("div", { className: "component-tree-item__right" },
                    React.createElement("div", { className: "component-tree-item__actions-container" }, renderActions())))));
    }
    // Fallback for invalid data
    return React.createElement("div", { className: "component-tree-item component-tree-item--error" }, "Invalid item data");
}
